// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BaseRadio__option___3sDbG:not(:last-child){margin-bottom:4px}.BaseRadio__radio___4NnXW{position:relative;top:1px}", ""]);
// Exports
exports.locals = {
	"option": "BaseRadio__option___3sDbG",
	"radio": "BaseRadio__radio___4NnXW"
};
module.exports = exports;
